import { vuex as dashboard } from './dashboard'
import { vuex as tradle } from './tradle'
import { vuex as user } from './user'
import { vuex as auth } from './auth'
import { vuex as shipment } from './shipment'
import { vuex as minsk } from './minsk'
import { vuex as regions } from './regions'

export default {
  dashboard,
  tradle,
  user,
  auth,
  shipment,
  minsk,
  regions
}
